import { FC } from "react"
import styles from "./preloader.module.scss"

const Preloader: FC = () => {
    return (
        <div className={styles.preloader}></div>
    )
}

export default Preloader